import React, { useState } from 'react'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import { DataLoader } from '@/components/dataLoader'
import { WhiteBox } from '@/components/Layout'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { defaultDateTimeSecondFormat, formatDate } from '@/utils/dateUtilities'
import { Button } from '@/components/button'
import LoadingIndicator from '@/components/LoadingIndicator'
import { actionButtonsColumnProps, BsrsGrid, Column, createGenericCell } from '@/components/BsrsGrid'
import { getChangeItemUrl } from '@/components/changeRequests/urls'
import Icon from '@/components/Icon'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'

export const ChangeRequest = React.memo(function ChangeRequest ({ dataSource, isDraft = false, onChangeRequestCreated, reloadCount = 0 }) {
  const { localize } = useLocalization()
  const [refreshTime, setRefreshTime] = useState(new Date())
  const [deleting, setDeleting] = useState(false)
  const [creating, setCreating] = useState(false)

  const openValidationErrorDialog = (item) => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.validationErrors,
      errorInfo: item.validationErrors
    }))
  }

  const openChangeRequestErrorDialog = () => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.alert,
      title: 'Common.Error',
      content: 'Tickets.ValidationError'
    }))
  }

  function onItemDelete (changeItemId) {
    setDeleting(true)
    context.api.changeRequestService.deleteChangeItem(changeItemId)
      .then(() => {
        setRefreshTime(new Date())
        setDeleting(false)
      })
      .catch(() => setDeleting(false))
  }

  function onCreateChangeRequest () {
    setCreating(true)
    context.api.changeRequestService.createChangeRequest()
      .then(() => {
        setRefreshTime(new Date())
        setCreating(false)
        if (typeof onChangeRequestCreated === 'function') onChangeRequestCreated()
      })
      .catch(() => {
        setCreating(false)
        openChangeRequestErrorDialog()
      })
  }

  return (
    <DataLoader key={`${reloadCount}_${refreshTime}`} dataSource={dataSource} render={e =>
      <WhiteBox dataCy='ChangeRequestBox' header={isDraft ? 'Tasks.ChangeRequestDraft' : 'Tasks.ChangeRequest'} buttons={
        <React.Fragment>
          {e.data && e.data.lastModificationTime
            ? <InfoRow>
              <InfoLabel size={'lg'}>{localize('Common.LastModificationTime')}</InfoLabel>
              <InfoContent>{formatDate(e.data.lastModificationTime, defaultDateTimeSecondFormat)}</InfoContent>
            </InfoRow>
            : null
          }
          {isDraft && e.data && e.data.items && e.data.items.length > 0
            ? <Button color='primary' disabled={e.data.items.filter(i => i.validationErrors !== null).length} onClick={onCreateChangeRequest} confirmTitle='Tasks.CreateChangeRequestConfirmTitle' confirmText='Tasks.CreateChangeRequestConfirmContent'>{localize('Tasks.CreateChangeRequest')}</Button>
            : null
          }
        </React.Fragment>}>
        {(e.loading || deleting || creating)
          ? <LoadingIndicator />
          : <BsrsGrid simpleView data={(e.data && e.data.items) || []}>
            <Column field='scope' title={localize('Tasks.ChangeItemOperation')} cell={createGenericCell(
              item => localize(item.scope === 'Individuals' ? (item.targetId ? 'Tasks.IndividualChanged' : 'Tasks.IndividualAdded') : 'Tasks.InstitutionDetailChanged'))} />
            <Column field='validationErrorsCount' title={localize('Tasks.ChangeItemErrors')} cell={createGenericCell(
              item => item.validationErrorsCount > 0
                ? <Button onClick={() => openValidationErrorDialog(item)} className='red d-flex align-items-center'><Icon name='error' />&nbsp;{item.validationErrorsCount}</Button>
                : <React.Fragment><Icon name='check green' />{localize('Tasks.ChangeItemNoErrors')}</React.Fragment>)} />
            <Column {...actionButtonsColumnProps([
              { url: x => getChangeItemUrl(x.scope, x.id), icon: 'show' },
              isDraft ? { onDelete: item => onItemDelete(item.id) } : null
            ].filter(Boolean))} />
          </BsrsGrid>}
      </WhiteBox>
    } />
  )
})



// WEBPACK FOOTER //
// ./src/report-app/pages/changeRequests/changeRequest.js